export let apiVariables = {
    apiLink: '/api/',
    headers: {
        'accept': 'application/json',
        'Content-Type': 'application/json'
    },
    credentials: "same-origin"
}



// WEBPACK FOOTER //
// ./src/utils/variables.js